import axios from 'axios'

export default axios.create({
  responseType: 'json',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    // 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
  }
})
